/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["полунощ", "сутринта", "на обяд", "следобед", "вечерта", "през нощта"], u, u], u, ["00:00", ["04:00", "11:00"], ["11:00", "14:00"], ["14:00", "18:00"], ["18:00", "22:00"], ["22:00", "04:00"]]];
